// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: '3.8.0',
  USERDATA_KEY: 'authf649fc9a5f55',
  //isMockEnabled: true,
  //apiUrl: 'https://your-domain.com/api'
  isMockEnabled: false,
  // apiUrl: 'http://127.0.0.1:8000/api',
  apiUrl: 'http://192.168.0.168:8000/api'
  //apiUrl: 'http://192.168.0.99:8077/public/index.php/api'
};
